import { createSlice } from "@reduxjs/toolkit";

export const get_disease = createSlice({
  name: "disease_info",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateStoreDiseases: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateStoreDiseases } = get_disease.actions;

export default get_disease.reducer;
